import React from 'react';
var Header = function () { return (React.createElement("header", { className: 'header' })); };
export default Header;
